import { decode } from 'base-64';
import Config from '@betty/toolkit/config';
import { SmarticoConfig } from '../state';
import { logError } from '@betty/toolkit/logging';

export let config: SmarticoConfig;

if (Config.SMARTICO_CONFIG) {
  try {
    const parsedConfig = JSON.parse(decode(Config.SMARTICO_CONFIG));

    config = parsedConfig;
  } catch (e) {
    logError('Smartico config parse error', e);
  }
}
